export default __webpack_public_path__ + "static/media/10.156263f1.png";